import {
  reportError,
  throwAndReportError
} from '../../error-handling/reportError';
import { keys } from '../../utils/Object';
import { pathContentSchema, staticContentSchema } from './schemas';
import {
  Typo3PathContentResponse,
  Typo3RequestInfo,
  Typo3StaticContentResponse
} from './types';
import { T3Config } from './types/configs';

export const assertStaticContent = async (
  staticContent: Typo3StaticContentResponse
) => {
  if (process.env.REACT_APP_VALIDATE_SCHEMA !== 'yes') {
    return;
  }

  // console.log({ assertStaticContent: staticContent });
  try {
    await staticContentSchema.validate(staticContent);
  } catch (e) {
    // TODO: report issue via `reportError`
    //console.log('assertStaticContent:', e, 'content:', staticContent);
    reportError('assertStaticContent', e);
  }
};

export const assertPathContent = async (
  pathContent: Typo3PathContentResponse
) => {
  if (process.env.REACT_APP_VALIDATE_SCHEMA !== 'yes') {
    return;
  }

  // console.log({ assertPathContent: pathContent });
  try {
    await pathContentSchema.validate(pathContent);
  } catch (e) {
    // TODO: report issue via `reportError`
    console.log('assertPathContent:', e, 'data:', pathContent);
    reportError('assertPathContent', e);
  }
};

export const assertRequestObject = async (
  config: T3Config,
  requestInfo: Typo3RequestInfo
) => {
  if (process.env.REACT_APP_VALIDATE_SCHEMA !== 'yes') {
    return;
  }

  const valid = keys(config).every(key => {
    const configValue = config[key].toString();
    const infoValue = requestInfo[key];
    return configValue === infoValue;
  });
  if (!valid) {
    await throwAndReportError(
      'assertRequestObject',
      `T3Config (${JSON.stringify(config)}) and RequestInfo (${JSON.stringify(
        requestInfo
      )}) do not match!`
    );
  }
};
